import request from '@/router/axios'

export function fetchRankingList(params) {
  return request({
    url: '/admin/admin/ranking/page',
    method: 'get',
    params
  })
}

export function fetchRankingDetail(params) {
  return request({
    url: '/admin/admin/ranking/detail/page',
    method: 'get',
    params
  })
}
